/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

import { OperationMeta } from '@flowgram.ai/history';

import { changeFormValueOperationMeta } from './change-form-values';

export const operationMetas: OperationMeta[] = [changeFormValueOperationMeta];
